

export const environment = {
  production: false,
  googleAnalyticsId: 'G-M9Z4GJWDJR'
};


// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
